var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_362:3494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5121 20C16.1493 20 20.7192 15.5228 20.7192 10C20.7192 4.47715 16.1493 0 10.5121 0C4.87482 0 0.304932 4.47715 0.304932 10C0.304932 15.5228 4.87482 20 10.5121 20Z",
    fill: "#FFA800"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5122 5C11.0736 5 11.5329 5.45 11.5329 6V12C11.5329 12.55 11.0736 13 10.5122 13C9.95078 13 9.49146 12.55 9.49146 12V6C9.49146 5.45 9.95078 5 10.5122 5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5122 16C11.0759 16 11.5329 15.5523 11.5329 15C11.5329 14.4477 11.0759 14 10.5122 14C9.94844 14 9.49146 14.4477 9.49146 15C9.49146 15.5523 9.94844 16 10.5122 16Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_362:3494"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.4142,
    height: 20,
    fill: "white",
    transform: "translate(0.304932)"
  })))));
};
export default SvgWarning;